// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { PathDbPathInfo } from './Formatters'

import {
  ACMTooltip,
  AdditionalAntennaTooltip,
  FormatAntenna,
  FormatElevationHeader,
  FormatRadio,
  PassiveTooltip,
  PathInfoHeader,
  PathSiteNames,
  PathSummaryCell,
  SiteNameHeader,
} from 'components/PathSummary/components'

const columns = [{
  cellFormatter: PathDbPathInfo,
  cellTooltip: PassiveTooltip,
  columnKey: 'pathInfo',
  columnHeader: 'Path Info',
  columnWidth: '260px',
  headerFormatter: PathInfoHeader,
  sortable: true,
}, {
  cellFormatter: PathSiteNames,
  columnKey: 'siteName',
  columnHeader: 'Site Name',
  headerFormatter: SiteNameHeader,
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'callSign',
  columnHeader: 'Call Sign',
  columnWidth: '85px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'serviceContactCode',
  columnHeader: 'Contact',
  columnWidth: '85px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'latitude',
  columnHeader: 'Latitude',
  columnWidth: '120px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'longitude',
  columnHeader: 'Longitude',
  columnWidth: '120px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'groundElevation',
  columnHeader: 'G.E.',
  columnWidth: '70px',
  headerFormatter: FormatElevationHeader,
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'stateCode',
  columnHeader: 'State',
  columnWidth: '50px',
}, {
  cellFormatter: FormatAntenna,
  cellTooltip: AdditionalAntennaTooltip,
  columnKey: 'antennas',
  columnHeader: 'Antenna',
  columnWidth: '160px',
}, {
  cellFormatter: FormatRadio,
  cellTooltip: ACMTooltip,
  columnKey: 'radio',
  columnHeader: 'Radio',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'bandwidth',
  columnHeader: 'BW (MHz)',
  columnHeaderTitle: 'Channel Bandwidth',
  columnWidth: '100px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'numberOfFrequencies',
  columnHeader: '# CH',
  columnWidth: '50px',
}, {
  cellFormatter: PathSummaryCell,
  columnKey: 'segmentStatus',
  columnHeader: 'Status',
  columnWidth: '50px',
}]

export default columns

